import React, { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import utils from '../utils/Utils';
// import Menu from './Menu';
import VideoGallery from '../components/VideoGallery';
import backgroundImage from '../assets/ClipdeoHome.png'

const Layout = ({ children }) => {
  useEffect(() => {
    utils.scaleMobile();
  
    return () => {
    }
  }, [])
  
  return (
  <>
    <div>
        {/* <Menu /> */}
        <div className="page-content">
          <div className="min-h-[calc(75vh-64px)] flex-1 items-center justify-center bg-cover bg-center bg-no-repeat bg-fixed"
            style={{
              backgroundImage: `url(${backgroundImage})`,
            }}
          >
            <div className="min-h-[calc(75vh-64px)] flex items-center justify-center">
              {children}
            </div>
            <div className='min-h-[calc(25vh)] flex items-center justify-center pb-4'>
                <VideoGallery />
            </div>
          </div>
        </div>
        <ToastContainer
            position="bottom-right"
            autoClose={4000}
            draggable
            hideProgressBar={true}
        />
    </div>
  </>
  );
};

export default Layout;

